import React from 'react';

const Badge = ({ children, className = '' }) => (
  <div className={`inline-flex items-center gap-2 bg-gradient-to-r from-red-100 to-red-200 text-red-700 px-6 py-3 rounded-full text-sm font-medium border border-red-200 shadow-sm animate-pulse ${className}`}>
    {children}
  </div>
);

export default Badge;
